var map = {
	"./403.vue": "00a5",
	"./404.vue": "8cdb",
	"./bidPrice/addBidPrice.vue": "d565",
	"./bidPrice/bidPriceDetail.vue": "6ca1a",
	"./bidPrice/fail.vue": "a6b4",
	"./bidPrice/index.vue": "c477",
	"./company/companyDetail.vue": "7c7f",
	"./company/index.vue": "28b1",
	"./error.vue": "0636",
	"./home/components/panelGroup.vue": "843d",
	"./home/index.vue": "7abe",
	"./home/message.vue": "4f79",
	"./home/personal-info.vue": "f909f",
	"./login.vue": "dd7b",
	"./order/index.vue": "634a",
	"./order/orderDetail.vue": "f2cf",
	"./permission/index.vue": "c23a",
	"./product/addCategory.vue": "29b2",
	"./product/addGoods.vue": "4ca2",
	"./product/addStorage.vue": "e122",
	"./product/category.vue": "71ab",
	"./product/editCategory.vue": "e8a7",
	"./product/editGoods.vue": "c419",
	"./product/editStorage.vue": "4b5b",
	"./product/index.vue": "e6e2",
	"./product/storage.vue": "41d7",
	"./purchase/SmallPurchase.vue": "4d73",
	"./purchase/addPurchase.vue": "a20c",
	"./purchase/index.vue": "5918",
	"./purchase/smallTaskDetail.vue": "3681",
	"./purchase/task-detail.vue": "e652",
	"./reback/index.vue": "7194",
	"./reback/returnDetail.vue": "14c1",
	"./receive/addReceive.vue": "8ea1",
	"./receive/index.vue": "f4dd",
	"./receive/receiveDetail.vue": "82af",
	"./register.vue": "7803",
	"./restaurant/addRes.vue": "0e7d",
	"./restaurant/editRes.vue": "f85b",
	"./restaurant/index.vue": "700b",
	"./role/addRole.vue": "095e",
	"./role/index.vue": "6c35",
	"./role/role-permission.vue": "63d9",
	"./role/roleDetail.vue": "d0d2",
	"./sender/addSender.vue": "4127",
	"./sender/index.vue": "e1b9",
	"./sender/senderDetail.vue": "b853",
	"./staff/addStaff.vue": "b92c",
	"./staff/detail.vue": "17ea",
	"./staff/index.vue": "b97d",
	"./staff/userIndex.vue": "7c20",
	"./stock/detail.vue": "51c1",
	"./stock/index.vue": "024c",
	"./supplier/addBind.vue": "8756",
	"./supplier/bind.vue": "6381",
	"./supplier/index.vue": "4f2d",
	"./supplier/supplierDetail.vue": "993d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "feca";